import { env } from "./config/env";

export const state = {
  relatedProducts: null,
}

console.log('envenvenvenvenvenv',env)
export const getAllProductsWithType = async (language, type = null) => {
  let queryString = "";
  if(type) queryString = `product_type:${type}`;

  try {
      const query = `
      query GET_PRODUCTS {
          products (first: 10, query:"${queryString}") {
              edges {
                  node {
                    availableForSale
                    title                                          
                    handle
                    productType
                    totalInventory
                    id   
                    tags
                    
                    variants(first: 10) {
                      edges {
                        node {   
                          id          
                          title
                          quantityAvailable
                          availableForSale     
                          priceV2 {
                            amount
                          }                                                               
                        }
                      }
                    }                      

                    images(first:1) {
                      edges {
                        node {
                          altText
                          originalSrc
                        }
                      }
                    }
                    priceRange {
                      minVariantPrice {
                        amount
                      }
                    }
                    compareAtPriceRange {
                      maxVariantPrice {
                        amount
                      }
                    }
                  }
              }
        }
      }
    `;
    
      const getProductsResult = await axios.post(env.STOREFRONT_URL, {query}, { headers: {
      "Content-Type" : "application/json",
        "X-Shopify-Storefront-Access-Token" : env.STOREFRONT_KEY,
      "Accept-Language": language
    }}); 

    const getProductsResultData = getProductsResult.data;
    if(!getProductsResultData) {
        state.relatedProducts = [];
        return;
    }

    const formattedProducts = getProductsResultData?.data?.products?.edges.map(edge => {
        return {
            "productType": edge?.node?.productType,
            "productAvailableForSale": edge?.node?.availableForSale,                                     
            "title": edge?.node?.title,
            "id": edge?.node?.id,
            "handle": edge?.node?.handle,
            "image": edge?.node?.images?.edges[0]?.node,
            "variants": edge?.node?.variants?.edges.map(variantEdge => ({
              "id": variantEdge?.node?.id?.split("/").pop(),
              "title": variantEdge?.node?.title,
              "quantityAvailable": variantEdge?.node?.quantityAvailable,
              "availableForSale": variantEdge?.node?.availableForSale,
              "available" : variantEdge?.node?.availableForSale,
              "price": variantEdge?.node?.priceV2?.amount,
             })), 
            "productMinPrice": edge?.node?.priceRange?.minVariantPrice?.amount,
            "productMaxPrice": edge?.node?.compareAtPriceRange?.maxVariantPrice?.amount,
            "tags": edge?.node?.tags
        };
    });

    if(!formattedProducts) {
        state.relatedProducts = [];
        return;
    }

    state.relatedProducts = formattedProducts;

  }catch(err) {
      console.log(err.message)
  }

}

